import {
  Difficulties,
  DifficultyPops,
  ISettings,
  Region,
  Regions,
} from "../components/Settings";

export interface CountryData {
  code: string;
  name: string;
  continent: string;
  region: string;
  subregion: string;
  latLon: [number, number];
  capital: string | null;
  population: number;
  minor?: boolean;
  small?: boolean;
}

export function getCountryCodesWithDifficulty(
  difficulty: Difficulties,
  region: Regions
) {
  return countryList
    .filter(
      (country) =>
        (country.region === region || region === Region.All) &&
        (country.population >= DifficultyPops[difficulty] ||
          region !== Region.All)
    )
    .map((country) => country.code);
}

export function getCountryCodesWithSettings(settings: ISettings) {
  return getCountryCodesWithDifficulty(
    settings.difficulty as Difficulties,
    settings.region as Regions
  );
}

export function getCountryInfo(countryCode: string) {
  return countryList.find((country) => country.code === countryCode);
}

export const countryList: CountryData[] = [
  {
    code: "AW",
    name: "Aruba",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [12.5, -69.96666666],
    capital: "Oranjestad",
    population: 115120,
    minor: true,
    small: true,
  },
  {
    code: "AF",
    name: "Afghanistan",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [33, 65],
    capital: "Kabul",
    population: 34124811,
  },
  {
    code: "AO",
    name: "Angola",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [-12.5, 18.5],
    capital: "Luanda",
    population: 29310273,
  },
  {
    code: "AI",
    name: "Anguilla",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.25, -63.16666666],
    capital: "The Valley",
    population: 17087,
    minor: true,
    small: true,
  },
  {
    code: "AL",
    name: "Albania",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [41, 20],
    capital: "Tirana",
    population: 3047987,
  },
  {
    code: "AX",
    name: "Åland Islands",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [60.116667, 19.9],
    capital: "Mariehamn",
    population: 27153,
    minor: true,
    small: true,
  },
  {
    code: "AD",
    name: "Andorra",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [42.5, 1.5],
    capital: "Andorra la Vella",
    population: 85702,
    minor: true,
    small: true,
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [24, 54],
    capital: "Abu Dhabi",
    population: 6072475,
  },
  {
    code: "AR",
    name: "Argentina",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-34, -64],
    capital: "Buenos Aires",
    population: 44293293,
  },
  {
    code: "AM",
    name: "Armenia",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [40, 45],
    capital: "Yerevan",
    population: 3045191,
  },
  {
    code: "AS",
    name: "American Samoa",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-14.33333333, -170],
    capital: "Pago Pago",
    population: 51504,
    minor: true,
    small: true,
  },
  {
    code: "AQ",
    name: "Antarctica",
    continent: "Other",
    region: "Other",
    subregion: "Other",
    latLon: [-90, 0],
    capital: null,
    population: 4050,
  },
  {
    code: "TF",
    name: "French Southern and Antarctic Lands",
    continent: "Other",
    region: "Other",
    subregion: "Other",
    latLon: [-49.25, 69.167],
    capital: "Port-aux-Français",
    population: 140,
    minor: true,
    small: true,
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [17.05, -61.8],
    capital: "Saint John's",
    population: 94731,
    minor: true,
    small: true,
  },
  {
    code: "AU",
    name: "Australia",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Australia and New Zealand",
    latLon: [-27, 133],
    capital: "Canberra",
    population: 23232413,
  },
  {
    code: "AT",
    name: "Austria",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [47.33333333, 13.33333333],
    capital: "Vienna",
    population: 8754413,
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [40.5, 47.5],
    capital: "Baku",
    population: 9961396,
  },
  {
    code: "BI",
    name: "Burundi",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-3.5, 30],
    capital: "Bujumbura",
    population: 11466756,
  },
  {
    code: "BE",
    name: "Belgium",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [50.83333333, 4],
    capital: "Brussels",
    population: 11491346,
  },
  {
    code: "BJ",
    name: "Benin",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [9.5, 2.25],
    capital: "Porto-Novo",
    population: 11038805,
  },
  {
    code: "BF",
    name: "Burkina Faso",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [13, -2],
    capital: "Ouagadougou",
    population: 20107509,
  },
  {
    code: "BD",
    name: "Bangladesh",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [24, 90],
    capital: "Dhaka",
    population: 157826578,
  },
  {
    code: "BG",
    name: "Bulgaria",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [43, 25],
    capital: "Sofia",
    population: 7101510,
  },
  {
    code: "BH",
    name: "Bahrain",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [26, 50.55],
    capital: "Manama",
    population: 1410942,
  },
  {
    code: "BS",
    name: "Bahamas",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [24.25, -76],
    capital: "Nassau",
    population: 329988,
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [44, 18],
    capital: "Sarajevo",
    population: 3856181,
  },
  {
    code: "BL",
    name: "Saint-Barthélemy",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.5, -63.41666666],
    capital: "Gustavia",
    population: 7184,
    minor: true,
    small: true,
  },
  {
    code: "BY",
    name: "Belarus",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [53, 28],
    capital: "Minsk",
    population: 9549747,
  },
  {
    code: "BZ",
    name: "Belize",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [17.25, -88.75],
    capital: "Belmopan",
    population: 360346,
  },
  {
    code: "BM",
    name: "Bermuda",
    continent: "North America",
    region: "Americas",
    subregion: "Northern America",
    latLon: [32.33333333, -64.75],
    capital: "Hamilton",
    population: 70864,
    minor: true,
    small: true,
  },
  {
    code: "BO",
    name: "Bolivia",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-17, -65],
    capital: "Sucre",
    population: 11138234,
  },
  {
    code: "BR",
    name: "Brazil",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-10, -55],
    capital: "Brasília",
    population: 207353391,
  },
  {
    code: "BB",
    name: "Barbados",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [13.16666666, -59.53333333],
    capital: "Bridgetown",
    population: 292336,
    minor: true,
    small: true,
  },
  {
    code: "BN",
    name: "Brunei",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [4.5, 114.66666666],
    capital: "Bandar Seri Begawan",
    population: 443593,
  },
  {
    code: "BT",
    name: "Bhutan",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [27.5, 90.5],
    capital: "Thimphu",
    population: 758288,
  },
  {
    code: "BW",
    name: "Botswana",
    continent: "Africa",
    region: "Africa",
    subregion: "Southern Africa",
    latLon: [-22, 24],
    capital: "Gaborone",
    population: 2214858,
  },
  {
    code: "CF",
    name: "Central African Republic",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [7, 21],
    capital: "Bangui",
    population: 5625118,
  },
  {
    code: "CA",
    name: "Canada",
    continent: "North America",
    region: "Americas",
    subregion: "Northern America",
    latLon: [60, -95],
    capital: "Ottawa",
    population: 35623680,
  },
  {
    code: "CH",
    name: "Switzerland",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [47, 8],
    capital: "Bern",
    population: 8236303,
  },
  {
    code: "CL",
    name: "Chile",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-30, -71],
    capital: "Santiago",
    population: 17789267,
  },
  {
    code: "CN",
    name: "China",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [35, 105],
    capital: "Beijing",
    population: 1379302771,
  },
  {
    code: "CI",
    name: "Ivory Coast",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [8, -5],
    capital: "Yamoussoukro",
    population: 24184810,
  },
  {
    code: "CM",
    name: "Cameroon",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [6, 12],
    capital: "Yaoundé",
    population: 24994885,
  },
  {
    code: "CD",
    name: "Democratic Republic of the Congo",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [0, 25],
    capital: "Kinshasa",
    population: 83301151,
  },
  {
    code: "CG",
    name: "Republic of the Congo",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [-1, 15],
    capital: "Brazzaville",
    population: 4954674,
  },
  {
    code: "CK",
    name: "Cook Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-21.23333333, -159.76666666],
    capital: "Avarua",
    population: 9290,
    minor: true,
    small: true,
  },
  {
    code: "CO",
    name: "Colombia",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [4, -72],
    capital: "Bogotá",
    population: 47698524,
  },
  {
    code: "KM",
    name: "Comoros",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-12.16666666, 44.25],
    capital: "Moroni",
    population: 808080,
    minor: true,
    small: true,
  },
  {
    code: "CV",
    name: "Cape Verde",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [16, -24],
    capital: "Praia",
    population: 560899,
    minor: true,
    small: true,
  },
  {
    code: "CR",
    name: "Costa Rica",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [10, -84],
    capital: "San José",
    population: 4930258,
  },
  {
    code: "CU",
    name: "Cuba",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [21.5, -80],
    capital: "Havana",
    population: 11147407,
  },
  {
    code: "CW",
    name: "Curaçao",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [12.116667, -68.933333],
    capital: "Willemstad",
    population: 149648,
    minor: true,
    small: true,
  },
  {
    code: "KY",
    name: "Cayman Islands",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [19.5, -80.5],
    capital: "George Town",
    population: 58441,
    minor: true,
    small: true,
  },
  {
    code: "CY",
    name: "Cyprus",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [35, 33],
    capital: "Nicosia",
    population: 1221549,
  },
  {
    code: "CZ",
    name: "Czech Republic",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [49.75, 15.5],
    capital: "Prague",
    population: 10674723,
  },
  {
    code: "DE",
    name: "Germany",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [51, 9],
    capital: "Berlin",
    population: 80594017,
  },
  {
    code: "DJ",
    name: "Djibouti",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [11.5, 43],
    capital: "Djibouti",
    population: 865267,
  },
  {
    code: "DM",
    name: "Dominica",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [15.41666666, -61.33333333],
    capital: "Roseau",
    population: 73897,
    minor: true,
    small: true,
  },
  {
    code: "DK",
    name: "Denmark",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [56, 10],
    capital: "Copenhagen",
    population: 5605948,
  },
  {
    code: "DO",
    name: "Dominican Republic",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [19, -70.66666666],
    capital: "Santo Domingo",
    population: 10734247,
  },
  {
    code: "DZ",
    name: "Algeria",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [28, 3],
    capital: "Algiers",
    population: 40969443,
  },
  {
    code: "EC",
    name: "Ecuador",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-2, -77.5],
    capital: "Quito",
    population: 16290913,
  },
  {
    code: "EG",
    name: "Egypt",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [27, 30],
    capital: "Cairo",
    population: 97041072,
  },
  {
    code: "ER",
    name: "Eritrea",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [15, 39],
    capital: "Asmara",
    population: 5918919,
  },
  {
    code: "ES",
    name: "Spain",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [40, -4],
    capital: "Madrid",
    population: 48958159,
  },
  {
    code: "EE",
    name: "Estonia",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [59, 26],
    capital: "Tallinn",
    population: 1251581,
  },
  {
    code: "ET",
    name: "Ethiopia",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [8, 38],
    capital: "Addis Ababa",
    population: 105350020,
  },
  {
    code: "FI",
    name: "Finland",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [64, 26],
    capital: "Helsinki",
    population: 5491218,
  },
  {
    code: "FJ",
    name: "Fiji",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Melanesia",
    latLon: [-18, 175],
    capital: "Suva",
    population: 920938,
  },
  {
    code: "FK",
    name: "Falkland Islands",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-51.75, -59],
    capital: "Stanley",
    population: 2931,
    minor: true,
    small: true,
  },
  {
    code: "FR",
    name: "France",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [46, 2],
    capital: "Paris",
    population: 67106161,
  },
  {
    code: "FO",
    name: "Faeroe Islands",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [62, -7],
    capital: "Tórshavn",
    population: 50730,
    minor: true,
    small: true,
  },
  {
    code: "FM",
    name: "Federated States of Micronesia",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [6.91666666, 158.25],
    capital: "Palikir",
    population: 104196,
    minor: true,
    small: true,
  },
  {
    code: "GA",
    name: "Gabon",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [-1, 11.75],
    capital: "Libreville",
    population: 1772255,
  },
  {
    code: "GB",
    name: "United Kingdom",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [54, -2],
    capital: "London",
    population: 64769452,
  },
  {
    code: "GE",
    name: "Georgia",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [42, 43.5],
    capital: "Tbilisi",
    population: 4926330,
  },
  {
    code: "GG",
    name: "Guernsey",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [49.46666666, -2.58333333],
    capital: "St. Peter Port",
    population: 66502,
    minor: true,
    small: true,
  },
  {
    code: "GH",
    name: "Ghana",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [8, -2],
    capital: "Accra",
    population: 27499924,
  },
  {
    code: "GI",
    name: "Gibraltar",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [36.13333333, -5.35],
    capital: "Gibraltar",
    population: 29396,
    minor: true,
    small: true,
  },
  {
    code: "GN",
    name: "Guinea",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [11, -10],
    capital: "Conakry",
    population: 12413867,
  },
  {
    code: "GM",
    name: "The Gambia",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [13.46666666, -16.56666666],
    capital: "Banjul",
    population: 2051363,
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [12, -15],
    capital: "Bissau",
    population: 1792338,
  },
  {
    code: "GQ",
    name: "Equatorial Guinea",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [2, 10],
    capital: "Malabo",
    population: 778358,
  },
  {
    code: "GR",
    name: "Greece",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [39, 22],
    capital: "Athens",
    population: 10768477,
  },
  {
    code: "GD",
    name: "Grenada",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [12.11666666, -61.66666666],
    capital: "St. George's",
    population: 111724,
    minor: true,
    small: true,
  },
  {
    code: "GL",
    name: "Greenland",
    continent: "North America",
    region: "Americas",
    subregion: "Northern America",
    latLon: [72, -40],
    capital: "Nuuk",
    population: 57713,
  },
  {
    code: "GT",
    name: "Guatemala",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [15.5, -90.25],
    capital: "Guatemala City",
    population: 15460732,
  },
  {
    code: "GU",
    name: "Guam",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [13.46666666, 144.78333333],
    capital: "Hagåtña",
    population: 167358,
    minor: true,
    small: true,
  },
  {
    code: "GY",
    name: "Guyana",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [5, -59],
    capital: "Georgetown",
    population: 737718,
  },
  {
    code: "HK",
    name: "Hong Kong",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [22.267, 114.188],
    capital: "City of Victoria",
    population: 7191503,
    small: true,
  },
  {
    code: "HN",
    name: "Honduras",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [15, -86.5],
    capital: "Tegucigalpa",
    population: 9038741,
  },
  {
    code: "HR",
    name: "Croatia",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [45.16666666, 15.5],
    capital: "Zagreb",
    population: 4292095,
  },
  {
    code: "HT",
    name: "Haiti",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [19, -72.41666666],
    capital: "Port-au-Prince",
    population: 10646714,
  },
  {
    code: "HU",
    name: "Hungary",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [47, 20],
    capital: "Budapest",
    population: 9850845,
  },
  {
    code: "ID",
    name: "Indonesia",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [-5, 120],
    capital: "Jakarta",
    population: 260580739,
  },
  {
    code: "IM",
    name: "Isle of Man",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [54.25, -4.5],
    capital: "Douglas",
    population: 88815,
    minor: true,
    small: true,
  },
  {
    code: "IN",
    name: "India",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [20, 77],
    capital: "New Delhi",
    population: 1281935911,
  },
  {
    code: "IO",
    name: "British Indian Ocean Territory",
    continent: "Other",
    region: "Other",
    subregion: "Other",
    latLon: [-6, 71.5],
    capital: "Diego Garcia",
    population: 4000,
    minor: true,
    small: true,
  },
  {
    code: "IE",
    name: "Ireland",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [53, -8],
    capital: "Dublin",
    population: 5011102,
  },
  {
    code: "IR",
    name: "Iran",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [32, 53],
    capital: "Tehran",
    population: 82021564,
  },
  {
    code: "IQ",
    name: "Iraq",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [33, 44],
    capital: "Baghdad",
    population: 39192111,
  },
  {
    code: "IS",
    name: "Iceland",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [65, -18],
    capital: "Reykjavik",
    population: 339747,
  },
  {
    code: "IL",
    name: "Israel",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [31.47, 35.13],
    capital: "Jerusalem",
    population: 8299706,
  },
  {
    code: "IT",
    name: "Italy",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [42.83333333, 12.83333333],
    capital: "Rome",
    population: 62137802,
  },
  {
    code: "JM",
    name: "Jamaica",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.25, -77.5],
    capital: "Kingston",
    population: 2990561,
  },
  {
    code: "JE",
    name: "Jersey",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [49.25, -2.16666666],
    capital: "Saint Helier",
    population: 98840,
    minor: true,
    small: true,
  },
  {
    code: "JO",
    name: "Jordan",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [31, 36],
    capital: "Amman",
    population: 10248069,
  },
  {
    code: "JP",
    name: "Japan",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [36, 138],
    capital: "Tokyo",
    population: 126451398,
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    continent: "Asia",
    region: "Asia",
    subregion: "Central Asia",
    latLon: [48, 68],
    capital: "Astana",
    population: 18556698,
  },
  {
    code: "KE",
    name: "Kenya",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [1, 38],
    capital: "Nairobi",
    population: 47615739,
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
    continent: "Asia",
    region: "Asia",
    subregion: "Central Asia",
    latLon: [41, 75],
    capital: "Bishkek",
    population: 5789122,
  },
  {
    code: "KH",
    name: "Cambodia",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [13, 105],
    capital: "Phnom Penh",
    population: 16204486,
  },
  {
    code: "KI",
    name: "Kiribati",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [1.41666666, 173],
    capital: "South Tarawa",
    population: 108145,
    minor: true,
    small: true,
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [17.33333333, -62.75],
    capital: "Basseterre",
    population: 52715,
    minor: true,
    small: true,
  },
  {
    code: "KR",
    name: "South Korea",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [37, 127.5],
    capital: "Seoul",
    population: 51181299,
  },
  {
    code: "XK",
    name: "Kosovo",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [42.666667, 21.166667],
    capital: "Pristina",
    population: 1895250,
  },
  {
    code: "KW",
    name: "Kuwait",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [29.5, 45.75],
    capital: "Kuwait City",
    population: 2875422,
  },
  {
    code: "LA",
    name: "Laos",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [18, 105],
    capital: "Vientiane",
    population: 7126706,
  },
  {
    code: "LB",
    name: "Lebanon",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [33.83333333, 35.83333333],
    capital: "Beirut",
    population: 6229794,
  },
  {
    code: "LR",
    name: "Liberia",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [6.5, -9.5],
    capital: "Monrovia",
    population: 4689021,
  },
  {
    code: "LY",
    name: "Libya",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [25, 17],
    capital: "Tripoli",
    population: 6653210,
  },
  {
    code: "LC",
    name: "Saint Lucia",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [13.88333333, -60.96666666],
    capital: "Castries",
    population: 164994,
    minor: true,
    small: true,
  },
  {
    code: "LI",
    name: "Liechtenstein",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [47.26666666, 9.53333333],
    capital: "Vaduz",
    population: 38244,
    small: true,
  },
  {
    code: "LK",
    name: "Sri Lanka",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [7, 81],
    capital: "Colombo",
    population: 22409381,
  },
  {
    code: "LS",
    name: "Lesotho",
    continent: "Africa",
    region: "Africa",
    subregion: "Southern Africa",
    latLon: [-29.5, 28.5],
    capital: "Maseru",
    population: 1958042,
  },
  {
    code: "LT",
    name: "Lithuania",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [56, 24],
    capital: "Vilnius",
    population: 2823859,
  },
  {
    code: "LU",
    name: "Luxembourg",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [49.75, 6.16666666],
    capital: "Luxembourg",
    population: 594130,
    small: true,
  },
  {
    code: "LV",
    name: "Latvia",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [57, 25],
    capital: "Riga",
    population: 1944643,
  },
  {
    code: "MO",
    name: "Macao",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [22.16666666, 113.55],
    capital: null,
    population: 601969,
    minor: true,
    small: true,
  },
  {
    code: "MF",
    name: "Saint-Martin",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.08333333, -63.95],
    capital: "Marigot",
    population: 32125,
    minor: true,
    small: true,
  },
  {
    code: "MA",
    name: "Morocco",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [32, -5],
    capital: "Rabat",
    population: 33986655,
  },
  {
    code: "MC",
    name: "Monaco",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [43.73333333, 7.4],
    capital: "Monaco",
    population: 30645,
  },
  {
    code: "MD",
    name: "Moldova",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [47, 29],
    capital: "Chișinău",
    population: 3474121,
  },
  {
    code: "MG",
    name: "Madagascar",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-20, 47],
    capital: "Antananarivo",
    population: 25054161,
  },
  {
    code: "MV",
    name: "Maldives",
    continent: "Other",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [3.25, 73],
    capital: "Malé",
    population: 392709,
    minor: true,
    small: true,
  },
  {
    code: "MX",
    name: "Mexico",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [23, -102],
    capital: "Mexico City",
    population: 124574795,
  },
  {
    code: "MH",
    name: "Marshall Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [9, 168],
    capital: "Majuro",
    population: 74539,
    minor: true,
    small: true,
  },
  {
    code: "MK",
    name: "Macedonia",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [41.83333333, 22],
    capital: "Skopje",
    population: 2103721,
  },
  {
    code: "ML",
    name: "Mali",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [17, -4],
    capital: "Bamako",
    population: 17885245,
  },
  {
    code: "MT",
    name: "Malta",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [35.83333333, 14.58333333],
    capital: "Valletta",
    population: 416338,
    minor: true,
    small: true,
  },
  {
    code: "MM",
    name: "Myanmar",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [22, 98],
    capital: "Naypyidaw",
    population: 55123814,
  },
  {
    code: "ME",
    name: "Montenegro",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [42.5, 19.3],
    capital: "Podgorica",
    population: 642550,
  },
  {
    code: "MN",
    name: "Mongolia",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [46, 105],
    capital: "Ulan Bator",
    population: 3068243,
  },
  {
    code: "MP",
    name: "Northern Mariana Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [15.2, 145.75],
    capital: "Saipan",
    population: 52263,
    minor: true,
    small: true,
  },
  {
    code: "MZ",
    name: "Mozambique",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-18.25, 35],
    capital: "Maputo",
    population: 26573706,
  },
  {
    code: "MR",
    name: "Mauritania",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [20, -12],
    capital: "Nouakchott",
    population: 3758571,
  },
  {
    code: "MS",
    name: "Montserrat",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [16.75, -62.2],
    capital: "Plymouth",
    population: 5292,
    minor: true,
    small: true,
  },
  {
    code: "MU",
    name: "Mauritius",
    continent: "Other",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-20.28333333, 57.55],
    capital: "Port Louis",
    population: 1356388,
    minor: true,
    small: true,
  },
  {
    code: "MW",
    name: "Malawi",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-13.5, 34],
    capital: "Lilongwe",
    population: 19196246,
  },
  {
    code: "MY",
    name: "Malaysia",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [2.5, 112.5],
    capital: "Kuala Lumpur",
    population: 31381992,
  },
  {
    code: "NA",
    name: "Namibia",
    continent: "Africa",
    region: "Africa",
    subregion: "Southern Africa",
    latLon: [-22, 17],
    capital: "Windhoek",
    population: 2484780,
  },
  {
    code: "NC",
    name: "New Caledonia",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Melanesia",
    latLon: [-21.5, 165.5],
    capital: "Nouméa",
    population: 279070,
    minor: true,
    small: true,
  },
  {
    code: "NE",
    name: "Niger",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [16, 8],
    capital: "Niamey",
    population: 19245344,
  },
  {
    code: "NF",
    name: "Norfolk Island",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Australia and New Zealand",
    latLon: [-29.03333333, 167.95],
    capital: "Kingston",
    population: 2210,
    minor: true,
    small: true,
  },
  {
    code: "NG",
    name: "Nigeria",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [10, 8],
    capital: "Abuja",
    population: 190632261,
  },
  {
    code: "NI",
    name: "Nicaragua",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [13, -85],
    capital: "Managua",
    population: 6025951,
  },
  {
    code: "NU",
    name: "Niue",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-19.03333333, -169.86666666],
    capital: "Alofi",
    population: 1626,
    minor: true,
    small: true,
  },
  {
    code: "NL",
    name: "Netherlands",
    continent: "Europe",
    region: "Europe",
    subregion: "Western Europe",
    latLon: [52.5, 5.75],
    capital: "Amsterdam",
    population: 17084719,
  },
  {
    code: "NO",
    name: "Norway",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [62, 10],
    capital: "Oslo",
    population: 5320045,
  },
  {
    code: "NP",
    name: "Nepal",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [28, 84],
    capital: "Kathmandu",
    population: 29384297,
  },
  {
    code: "NR",
    name: "Nauru",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [-0.53333333, 166.91666666],
    capital: "Yaren",
    population: 9642,
    minor: true,
    small: true,
  },
  {
    code: "NZ",
    name: "New Zealand",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Australia and New Zealand",
    latLon: [-41, 174],
    capital: "Wellington",
    population: 4510327,
  },
  {
    code: "OM",
    name: "Oman",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [21, 57],
    capital: "Muscat",
    population: 3424386,
  },
  {
    code: "PK",
    name: "Pakistan",
    continent: "Asia",
    region: "Asia",
    subregion: "Southern Asia",
    latLon: [30, 70],
    capital: "Islamabad",
    population: 204924861,
  },
  {
    code: "PA",
    name: "Panama",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [9, -80],
    capital: "Panama City",
    population: 3753142,
  },
  {
    code: "PN",
    name: "Pitcairn Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-25.06666666, -130.1],
    capital: "Adamstown",
    population: 54,
    minor: true,
    small: true,
  },
  {
    code: "PE",
    name: "Peru",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-10, -76],
    capital: "Lima",
    population: 31036656,
  },
  {
    code: "PH",
    name: "Philippines",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [13, 122],
    capital: "Manila",
    population: 104256076,
  },
  {
    code: "PW",
    name: "Palau",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Micronesia",
    latLon: [7.5, 134.5],
    capital: "Ngerulmud",
    population: 21431,
    minor: true,
    small: true,
  },
  {
    code: "PG",
    name: "Papua New Guinea",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Melanesia",
    latLon: [-6, 147],
    capital: "Port Moresby",
    population: 6909701,
  },
  {
    code: "PL",
    name: "Poland",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [52, 20],
    capital: "Warsaw",
    population: 38476269,
  },
  {
    code: "PR",
    name: "Puerto Rico",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.25, -66.5],
    capital: "San Juan",
    population: 3351827,
  },
  {
    code: "KP",
    name: "North Korea",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [40, 127],
    capital: "Pyongyang",
    population: 25248140,
  },
  {
    code: "PT",
    name: "Portugal",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [39.5, -8],
    capital: "Lisbon",
    population: 10839514,
  },
  {
    code: "PY",
    name: "Paraguay",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-23, -58],
    capital: "Asunción",
    population: 6943739,
  },
  {
    code: "PS",
    name: "Palestine",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [31.9, 35.2],
    capital: "Ramallah",
    population: 4543126,
  },
  {
    code: "PF",
    name: "French Polynesia",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-15, -140],
    capital: "Papeetē",
    population: 287881,
    minor: true,
    small: true,
  },
  {
    code: "QA",
    name: "Qatar",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [25.5, 51.25],
    capital: "Doha",
    population: 2314307,
  },
  {
    code: "RO",
    name: "Romania",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [46, 25],
    capital: "Bucharest",
    population: 21529967,
  },
  {
    code: "RU",
    name: "Russia",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [60, 100],
    capital: "Moscow",
    population: 142257519,
  },
  {
    code: "RW",
    name: "Rwanda",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-2, 30],
    capital: "Kigali",
    population: 11901484,
  },
  {
    code: "EH",
    name: "Western Sahara",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [24.5, -13],
    capital: "El Aaiún",
    population: 603253,
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [25, 45],
    capital: "Riyadh",
    population: 28571770,
  },
  {
    code: "SD",
    name: "Sudan",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [15, 30],
    capital: "Khartoum",
    population: 37345935,
  },
  {
    code: "SS",
    name: "South Sudan",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [7, 30],
    capital: "Juba",
    population: 13026129,
  },
  {
    code: "SN",
    name: "Senegal",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [14, -14],
    capital: "Dakar",
    population: 14668522,
  },
  {
    code: "SG",
    name: "Singapore",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [1.36666666, 103.8],
    capital: "Singapore",
    population: 5888926,
  },
  {
    code: "GS",
    name: "South Georgia and the Islands",
    continent: "Other",
    region: "Other",
    subregion: "Other",
    latLon: [-54.5, -37],
    capital: "King Edward Point",
    population: 30,
    minor: true,
    small: true,
  },
  {
    code: "SB",
    name: "Solomon Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Melanesia",
    latLon: [-8, 159],
    capital: "Honiara",
    population: 647581,
  },
  {
    code: "SL",
    name: "Sierra Leone",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [8.5, -11.5],
    capital: "Freetown",
    population: 6163195,
  },
  {
    code: "SV",
    name: "El Salvador",
    continent: "North America",
    region: "Americas",
    subregion: "Central America",
    latLon: [13.83333333, -88.91666666],
    capital: "San Salvador",
    population: 6172011,
  },
  {
    code: "SM",
    name: "San Marino",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [43.76666666, 12.41666666],
    capital: "City of San Marino",
    population: 33537,
    minor: true,
    small: true,
  },
  {
    code: "SO",
    name: "Somalia",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [10, 49],
    capital: "Mogadishu",
    population: 7531386,
  },
  {
    code: "PM",
    name: "Saint Pierre and Miquelon",
    continent: "North America",
    region: "Americas",
    subregion: "Northern America",
    latLon: [46.83333333, -56.33333333],
    capital: "Saint-Pierre",
    population: 5533,
    minor: true,
    small: true,
  },
  {
    code: "RS",
    name: "Serbia",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [44, 21],
    capital: "Belgrade",
    population: 7111024,
  },
  {
    code: "ST",
    name: "São Tomé and Principe",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [1, 7],
    capital: "São Tomé",
    population: 201025,
    minor: true,
    small: true,
  },
  {
    code: "SR",
    name: "Suriname",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [4, -56],
    capital: "Paramaribo",
    population: 591919,
  },
  {
    code: "SK",
    name: "Slovakia",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [48.66666666, 19.5],
    capital: "Bratislava",
    population: 5445829,
  },
  {
    code: "SI",
    name: "Slovenia",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [46.11666666, 14.81666666],
    capital: "Ljubljana",
    population: 1972126,
  },
  {
    code: "SE",
    name: "Sweden",
    continent: "Europe",
    region: "Europe",
    subregion: "Northern Europe",
    latLon: [62, 15],
    capital: "Stockholm",
    population: 9960487,
  },
  {
    code: "SZ",
    name: "Swaziland",
    continent: "Africa",
    region: "Africa",
    subregion: "Southern Africa",
    latLon: [-26.5, 31.5],
    capital: "Lobamba",
    population: 1467152,
  },
  {
    code: "SX",
    name: "Sint Maarten",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.033333, -63.05],
    capital: "Philipsburg",
    population: 42083,
    minor: true,
    small: true,
  },
  {
    code: "SC",
    name: "Seychelles",
    continent: "Other",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-4.58333333, 55.66666666],
    capital: "Victoria",
    population: 93920,
    minor: true,
    small: true,
  },
  {
    code: "SY",
    name: "Syria",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [35, 38],
    capital: "Damascus",
    population: 18028549,
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [21.75, -71.58333333],
    capital: "Cockburn Town",
    population: 52570,
    minor: true,
    small: true,
  },
  {
    code: "TD",
    name: "Chad",
    continent: "Africa",
    region: "Africa",
    subregion: "Middle Africa",
    latLon: [15, 19],
    capital: "N'Djamena",
    population: 12075985,
  },
  {
    code: "TG",
    name: "Togo",
    continent: "Africa",
    region: "Africa",
    subregion: "Western Africa",
    latLon: [8, 1.16666666],
    capital: "Lomé",
    population: 7965055,
  },
  {
    code: "TH",
    name: "Thailand",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [15, 100],
    capital: "Bangkok",
    population: 68414135,
  },
  {
    code: "TJ",
    name: "Tajikistan",
    continent: "Asia",
    region: "Asia",
    subregion: "Central Asia",
    latLon: [39, 71],
    capital: "Dushanbe",
    population: 8468555,
  },
  {
    code: "TM",
    name: "Turkmenistan",
    continent: "Asia",
    region: "Asia",
    subregion: "Central Asia",
    latLon: [40, 60],
    capital: "Ashgabat",
    population: 5351277,
  },
  {
    code: "TL",
    name: "Timor-Leste",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [-8.83333333, 125.91666666],
    capital: "Dili",
    population: 1291358,
  },
  {
    code: "TO",
    name: "Tonga",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-20, -175],
    capital: "Nuku'alofa",
    population: 106479,
    minor: true,
    small: true,
  },
  {
    code: "TT",
    name: "Trinidad and Tobago",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [11, -61],
    capital: "Port of Spain",
    population: 1218208,
  },
  {
    code: "TN",
    name: "Tunisia",
    continent: "Africa",
    region: "Africa",
    subregion: "Northern Africa",
    latLon: [34, 9],
    capital: "Tunis",
    population: 11403800,
  },
  {
    code: "TR",
    name: "Turkey",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [39, 35],
    capital: "Ankara",
    population: 80845215,
  },
  {
    code: "TV",
    name: "Tuvalu",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-8, 178],
    capital: "Funafuti",
    population: 11052,
    minor: true,
    small: true,
  },
  {
    code: "TW",
    name: "Taiwan",
    continent: "Asia",
    region: "Asia",
    subregion: "Eastern Asia",
    latLon: [23.5, 121],
    capital: "Taipei",
    population: 23508428,
  },
  {
    code: "TZ",
    name: "Tanzania",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-6, 35],
    capital: "Dodoma",
    population: 53950935,
  },
  {
    code: "UG",
    name: "Uganda",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [1, 32],
    capital: "Kampala",
    population: 39570125,
  },
  {
    code: "UA",
    name: "Ukraine",
    continent: "Europe",
    region: "Europe",
    subregion: "Eastern Europe",
    latLon: [49, 32],
    capital: "Kiev",
    population: 44033874,
  },
  {
    code: "UM",
    name: "United States Minor Outlying Islands",
    continent: "North America",
    region: "Other",
    subregion: "Other",
    latLon: [19.2911437, 166.618332],
    capital: null,
    population: 300,
    minor: true,
    small: true,
  },
  {
    code: "UY",
    name: "Uruguay",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [-33, -56],
    capital: "Montevideo",
    population: 3360148,
  },
  {
    code: "US",
    name: "United States",
    continent: "North America",
    region: "Americas",
    subregion: "Northern America",
    latLon: [38, -97],
    capital: "Washington D.C.",
    population: 326625791,
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    continent: "Asia",
    region: "Asia",
    subregion: "Central Asia",
    latLon: [41, 64],
    capital: "Tashkent",
    population: 29748859,
  },
  {
    code: "VA",
    name: "Vatican",
    continent: "Europe",
    region: "Europe",
    subregion: "Southern Europe",
    latLon: [41.9, 12.45],
    capital: "Vatican City",
    population: 1000,
    small: true,
  },
  {
    code: "VC",
    name: "Saint Vincent and the Grenadines",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [13.25, -61.2],
    capital: "Kingstown",
    population: 102089,
    minor: true,
    small: true,
  },
  {
    code: "VE",
    name: "Venezuela",
    continent: "South America",
    region: "Americas",
    subregion: "South America",
    latLon: [8, -66],
    capital: "Caracas",
    population: 31304016,
  },
  {
    code: "VG",
    name: "British Virgin Islands",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.431383, -64.62305],
    capital: "Road Town",
    population: 35015,
    minor: true,
    small: true,
  },
  {
    code: "VI",
    name: "United States Virgin Islands",
    continent: "North America",
    region: "Americas",
    subregion: "Caribbean",
    latLon: [18.35, -64.933333],
    capital: "Charlotte Amalie",
    population: 107268,
    minor: true,
    small: true,
  },
  {
    code: "VN",
    name: "Vietnam",
    continent: "Asia",
    region: "Asia",
    subregion: "South-Eastern Asia",
    latLon: [16.16666666, 107.83333333],
    capital: "Hanoi",
    population: 96160163,
  },
  {
    code: "VU",
    name: "Vanuatu",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Melanesia",
    latLon: [-16, 167],
    capital: "Port Vila",
    population: 282814,
    minor: true,
    small: true,
  },
  {
    code: "WF",
    name: "Wallis and Futuna Islands",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-13.3, -176.2],
    capital: "Mata-Utu",
    population: 15714,
    minor: true,
    small: true,
  },
  {
    code: "WS",
    name: "Samoa",
    continent: "Oceania",
    region: "Oceania",
    subregion: "Polynesia",
    latLon: [-13.58333333, -172.33333333],
    capital: "Apia",
    population: 200108,
  },
  {
    code: "YE",
    name: "Yemen",
    continent: "Asia",
    region: "Asia",
    subregion: "Western Asia",
    latLon: [15, 48],
    capital: "Sana'a",
    population: 28036829,
  },
  {
    code: "ZA",
    name: "South Africa",
    continent: "Africa",
    region: "Africa",
    subregion: "Southern Africa",
    latLon: [-29, 24],
    capital: "Pretoria",
    population: 54841552,
  },
  {
    code: "ZM",
    name: "Zambia",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-15, 30],
    capital: "Lusaka",
    population: 15972000,
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    continent: "Africa",
    region: "Africa",
    subregion: "Eastern Africa",
    latLon: [-20, 30],
    capital: "Harare",
    population: 13805084,
  },
];
